import {CONFIG} from '../constants'


export const getAuthPageUrl = (redirectUrl?: string): string => {
  const authUrlWeb = new URL(CONFIG.executorAuthWeb + '/signin')
  authUrlWeb.searchParams.append('redirectUrl', redirectUrl ? redirectUrl : CONFIG.executorAuthWeb)
  return authUrlWeb.toString()
}
